export default __webpack_public_path__ + "static/media/newblp_Clients.bafc9c78.svg";